import { Typography } from "@mui/material"
import { TSaleItemStorage } from "../../../core/types/Sale"
import { Trans, useTranslation } from "react-i18next"

interface CourseDeliverySectionProps {
  items: TSaleItemStorage[]
  customerEmail: string
}

const CourseDeliverySection = ({
  items,
  customerEmail,
}: CourseDeliverySectionProps) => {
  const { t } = useTranslation()
  const productName = items.map((item) => item.name).filter(Boolean).join(", ")

  return (
    <>
      <Typography variant="body1" fontWeight={600} gutterBottom>
        {t("postPurchase.course.title")}
      </Typography>
      <Typography variant="body1" gutterBottom>
        <Trans
          i18nKey="postPurchase.course.step1"
          components={{ email: <strong>{customerEmail}</strong> }}
        />
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t("postPurchase.course.step2", { product: productName })}
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 3 }}>
        {t("postPurchase.course.step3")}
      </Typography>

      <Typography variant="body1" fontWeight={600} gutterBottom>
        {t("postPurchase.importantNotice")}
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 3 }}>
        {t("postPurchase.spamNotice")}
      </Typography>
    </>
  )
}

export default CourseDeliverySection
